import React from "react";
import { _size } from "../../core/core";
import "./Tab.css";

interface TabProps {
  stroke?: boolean;
  link?: string;
  text?: string;
  size?: _size;
  children?: React.ReactNode;
}

export const Tab: React.FC<TabProps> = ({
  stroke = true,
  link = "",
  text = "",
  size = _size.M,
  children,
  ...props
}) => {
  return (
    <a href={link} className={`tab tab-${size} tab-stroke-${stroke}`} {...props}>
      <div className="tab-body">
        <div className="tab-text">{text}</div>
      </div>
    </a>
  );
};
